import { useEffect, useState } from "react";
import Logo from "../qt_global_logo.png";
import Personal from "../components/application/personal";
import Education from "../components/application/education";
import Postions from "../components/application/postion";
import Experience from "../components/application/experience";
import Attachments from "../components/application/attachments";
import { fetchDetails, submitGeneralForm } from "../store/User/action";
import { useDispatch, useSelector } from "react-redux";
import { set, useForm } from "react-hook-form";
import {
  setEducation,
  setPersonalInfo,
  setWorkExperience,
  setOtherAttachments,
  setPostions,
} from "../store/slice/application";
import toast, { LoaderIcon } from "react-hot-toast";
import {
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  DialogContentText,
} from "@mui/material";
import { FormGroup, FormLabel } from "react-bootstrap";
import SelectedPostions from "../components/application/selectedPostion";
import { InfoOutlined } from "@mui/icons-material";

const Apply = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    control,
  } = useForm();
  const [activeButton, setActiveButton] = useState("");
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [rwanda, setRwanda] = useState(true);
  const [isLoadingPostions, setIsLoadingPostions] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const toggle = () => setModal(!modal);

  const dispatch = useDispatch();

  const { postions, otherAttachments } = useSelector(
    (state) => state.application
  );

  useEffect(() => {
    if (postions.length === 0) {
      setActiveButton("");
    }
  }, [postions]);



  const [fields, setFields] = useState([]);
  const [featchedPositions, setPositions] = useState([]);

  const [position, setPosition] = useState(null);
  const loadPositions = async () => {
    setIsLoadingPostions(true);
    const resp = await fetchDetails("position");
    if (resp.status) {
      setIsLoadingPostions(false);
      setPositions(resp.data.data);
    }else{
      setIsLoadingPostions(false);
    }
  };

  const loadFields = async () => {
    const resp = await fetchDetails("fields");
    if (resp.status) {
      const newFields = resp.data.data
        .filter((item) => item.status === true || item.status === 1)
        .map((v) => ({ value: v.id, label: v.name }));
      setFields([
        ...newFields,
        {
          value: "-",
          label: "Other",
        },
      ]);
    }
  };

  useEffect(() => {
    loadPositions().then();
    loadFields();
  }, []);

  const buttonTexts = [
    { label: "position",text: "position", icon: "place" },
    {label: "p.information", text: "about", icon: "info" },
    { label: "education",text: "education", icon: "school" },
    { label: "experience", text: "experience", icon: "work" },
    { label: "attachments",text: "attachments", icon: "attach_file" },
  ];

  const handlePrevious = () => {
    setLoading(false);
    const index = buttonTexts.findIndex((v) => v.text === activeButton);
    if(activeButton === "position"){
      setActiveButton("");
      return;
    }
    if (index > 0) {
      if (activeButton === "submit") {
        setActiveButton("experience");
      } else {
        setActiveButton(buttonTexts[index - 1].text);
      }
    }
  };

  const onSubmit = (data) => {

   if(activeButton === ""){
      if(postions.length === 0){
        toast.error("Please select at least one position",{
          duration: 5000,
          position: 'top-right',
        });
        return;
      }
      setActiveButton("position");
   }


    if (activeButton === "about") {
      dispatch(
        setPersonalInfo({
          fullname: data.names,
          phone: data.phone,
          email: data.email,
          nationality: data.nationality,
          id_or_passport: data.nationalId,
        })
      );
      setActiveButton("education");
    }

    if (activeButton === "position") {
      if (postions.length > 0) {
        setActiveButton("about");
      } else {
        toast.error("Please select at least one position");
        return;
      }
    }

    if (activeButton === "education") {
      dispatch(
        setEducation({
          level: data.education,
          field: data.studyField,
          other: data.otherSkill,
        })
      );
      setActiveButton("experience");
    }

    if (activeButton === "experience") {
      dispatch(
        setWorkExperience({
          employer: data.employer,
          experience: data.experience,
        })
      );
      setActiveButton("attachments");
    }

    if (activeButton === "attachments") {

      if(otherAttachments.length===0){
        toast.error("No Degree/Certificates attached, please attach at least one", {
          duration: 5000,
          position: 'top-right',
        });
        return;
      }

      if (data.positions?.length > 2) {
        toast.error("Not allowed to select more than two positions");
        return;
      }

     

      if (
        data.cv.length !== 0 &&
        data.nidAttachment.length !== 0

      ) {
        const formData = new FormData();

        Object.keys(data).forEach((v) => {
          let ob = data[v];
          if (typeof ob === "object") {
            if (Array.isArray(ob)) {
              ob.forEach((item) => {
                formData.append(v, item);
              });
            } else {
              formData.append(v, Array.from(ob)[0]);
            }
          } else {
            formData.append(v, ob);
          }
        });

        postions.forEach((v) => {
          formData.append("position", v.id);
        });


        formData.append("document", data.cv[0]);
        formData.append("documentName", "cv");
        formData.append("document", data.nidAttachment[0]);
        formData.append("documentName", "nidAttachment");


        otherAttachments.forEach((v) => {
            formData.append("document", v.file);
            formData.append("documentName", v.name);
            });

        formData.delete("degree");
        formData.delete("passport");

        submitForm(formData).then();
      }
      
    }

    return;
  };

  const submitForm = async (data) => {
    setLoading(true);
    const resp = await submitGeneralForm("/apply", data);
    if (resp.status) {

      toast.success(resp.data?.message ?? "Success !",{
        duration: 5000,
        position: 'top-right',
      })
      setTimeout(() => {
      window.location.href = "/";
      }
      , 5000);
    } else {
      toast.error(resp.data?.response?.data?.message ?? "Error !", {
        duration: 5000,
        position: 'top-right',
      });
    }
    setLoading(false);
  };

  const handlePostion = (postion) => {
    if (postion.requirements) {
      setPosition(postion);
    }
  };

  const handleApply = () => {

      if (postions.filter(item => item.id === position.id).length > 0) {
        dispatch(setPostions(postions.filter(item => item.id !== position.id)))
      } else {
        dispatch(setPostions([position]))
      }

  }


  return (
    <>
      <Dialog
        open={position !== null}
        onClose={() => {
          setPosition(null);
        }}
      >
        <DialogContent>
          <DialogContentText>
            <div
              dangerouslySetInnerHTML={{ __html: position?.requirements }}
            ></div>

          </DialogContentText>
       
        </DialogContent>
      {/* apply button */}
        <div className="flex justify-center py-2 ">
          {
            // check if the position is already in the list
            position && postions.filter(item => item.id === position.id).length > 0 ? (
              <Button
              sx={{backgroundColor: "#054163", color: "white", minWidth: "144px",
                "&:hover": {
                  backgroundColor: "#054166",
                  color: "white",
                },
              }}
                onClick={() => {
                  handleApply();
                  setPosition(null);
                }}
                color="error"
              >
                Remove
              </Button>
            ) : (
              <Button
              sx={{backgroundColor: "#054163", color: "white", minWidth: "144px",
                "&:hover": {
                  backgroundColor: "#054166",
                  color: "white",
                },
              }}
                onClick={() => {
                  handleApply();
                  setPosition(null);
                }}
                color="error"
              >
                Apply
              </Button>
            )
          }
      
        </div>
      </Dialog>

      <Dialog open={modal} onClose={toggle}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const data = new FormData(e.currentTarget);
            dispatch(
              setOtherAttachments([
                ...otherAttachments,
                {
                  name: data.get("name"),
                  file: data.get("file"),
                },
              ])
            );
            e.currentTarget.reset();
            toggle();
          }}
        >
          <DialogTitle toggle={toggle} className={"fw-bold"}>
            Document Details
          </DialogTitle>
          <DialogContent>
            <FormGroup className={"mb-3"}>
              <FormLabel className={"fw-bold"}>File Name</FormLabel>
              <input
                className={"form-control"}
                name={"name"}
                required={true}
                placeholder={"Name"}
              />
            </FormGroup>
            <FormGroup className={"mb-3"}>
              <FormLabel className={"fw-bold"}>Attach File</FormLabel>
              <input
                type={"file"}
                accept={"image/*,application/pdf"}
                required={true}
                name={"file"}
                className={"form-control"}
              />
            </FormGroup>
          </DialogContent>
          <DialogActions>
            <Button color="error" onClick={toggle}>
              Cancel
            </Button>{" "}
            <Button
              type={"submit"}
              style={{ backgroundColor: "#054163" }}
              variant={"contained"}
            >
              Add File
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <form
        onSubmit={handleSubmit(onSubmit)}
        className="container flex flex-col justify-center items-center rounded min-h-screen  "
      >
        <div className=" my-10 flex flex-col  justify-between items-center md:min-w-[800px]  shadow bg-white rounded min-h-[300px] ">
          <div className="social-inner">
            <img src={Logo} alt="logo" className="max-w-28" />
          </div>

          <div className="flex flex-col gap-1 items-center">
            <h2 className="md:text-[40px] font-bold text-[#3C4858] ">
              Job Application Form
            </h2>
            <p className="md:text-[20px] text[#000000DE] font-normal text-center">
              This information will let us know more about you.
            </p>
          </div>

          <div className={`flex flex-row md:flex-col md:flex-row gap-4 items-start justify-start md:w-full ${(postions && postions.length === 0) ? '':'bg-[#C8C8C833] '} `}>
            {
            (activeButton !== "") &&
            buttonTexts.map(({ label,text, icon }, index) => (
              <button
                type="button"
                key={index}
                className={`${
                  text === activeButton
                    ? "shadow-md text-center drop-shadow-2xl shadow-[#054163] bg-[#054163] text-white"
                    : ""
                } text-[12px] font-medium tracking-wide md:w-36 p-2 rounded text-[#55555] uppercase transition-transform duration-75 ease-in-out flex items-center justify-center`}
              >
                <span className="material-icons md:hidden">{icon}</span>

                <span className="hidden md:block">{label}</span>
              </button>
            ))}
          </div>

          <div className="flex flex-col gap-4 items-center px-2 w-full ">

            {
              activeButton === "" && featchedPositions.length>0 && (
                <Postions
                  handlePostionClick={handlePostion}
                  positions={featchedPositions}
                  register={register}
                  watch={watch}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  setRwanda={setRwanda}
                  setShowButton={setShowButton}
                  rwanda={rwanda}
                />
              )
            }


          {activeButton === "position" && (
              <SelectedPostions
                handlePostionClick={handlePostion}
                positions={featchedPositions}
                register={register}
                watch={watch}
                control={control}
                errors={errors}
                setValue={setValue}
                setRwanda={setRwanda}
                rwanda={rwanda}
              />
            )}

            {activeButton === "about" && (
              <Personal
                register={register}
                errors={errors}
                rwanda={rwanda}
                setRwanda={setRwanda}
              />
            )}
      
            {activeButton === "education" && (
              <Education fields={fields} register={register} errors={errors} />
            )}
            {activeButton === "experience" && (
              <Experience register={register} />
            )}
            {(activeButton === "attachments" || activeButton === "submit") && (
              <Attachments  toggle={toggle} watch={watch} errors={errors} register={register} />
            )}
          </div>

          {
            isLoadingPostions && (
              <div className="w-full flex flex-col gap-2 items-center p-4 mb-4">
              
                  <LoaderIcon
                  primary="#054163"
                  color="#054163"
                  
                   style={{
                    width: "30px",
                    height: "30px",
                    margin: "auto",
                  }} />
              
              </div>
            )
          }

          {
            (!isLoadingPostions && activeButton === "" && (featchedPositions.length === 0 || !showButton)) && (
              <div className="w-full flex flex-col gap-2 items-center p-4">
                <p className="text-center text-md text-[#FF0000] font-medium">No positions available at the moment
                         &nbsp;
                  <InfoOutlined className="text-[#FF0000]"/>
                </p>
              </div>
            )
          }

       {
        (featchedPositions.length !== 0 && showButton) &&  <div className="w-full flex  justify-between gap-2  bottom-0 px-2 md:px-4 py-4">
        <button
          type="button"
          onClick={() => handlePrevious()}
          className={`
                    ${
                      (activeButton === "")
                        ? "bg-disable text-white font-medium text-md tracking-wide w-36  py-2  rounded uppercase"
                        : "bg-[#054163] text-white font-medium text-md  tracking-wide w-36  py-2 rounded uppercase"
                    }
                    `}
        >
          Previous
        </button>
        <button
          type={`${loading ? "button" : "submit"}`}
          className={`${
            loading ? " bg-disable " : " bg-[#054163] "
          }text-white font-medium text-md tracking-wide  w-36 py-2 rounded uppercase`}
        >
          {activeButton==='attachments' ? (loading ? "Loading ..." : "Submit") : "Next"}
        </button>
      </div>
       }
       
        </div>

        <p class="text-center text-white tracking-wide bottom-5">
          QT Global © 
          {
            new Date().getFullYear()
          }
          . All Rights Reserved.
        </p>
      </form>
    </>
  );
};

export default Apply;
